"use client";

import dynamic from "next/dynamic";
import type { VidstackPlayerProps } from "./VidstackPlayer";

const VidstackPlayer = dynamic(() => import("./VidstackPlayer"), {
  ssr: false,
});

const VidstackPlayerDynamicWrapper = ({ ...props }: VidstackPlayerProps) => {
  return <VidstackPlayer {...props} />;
};

export default VidstackPlayerDynamicWrapper;
